import { runtimeConfig } from '@/shared/config'

// PUT /api/employees/me/timezone — ручка ХАБА (ID_BASE_URL), не своего бэка:
// проекция сотрудника живёт там. Адресата в пути нет — субъект берётся из
// hub-сессии, поэтому credentials: 'include' (кука хаба; CORS хаба пускает
// origin телемоста с PUT и credentials).
// Ручка идемпотентна: на совпавшей зоне хаб не пишет вовсе — сравнивать с
// сохранённым значением нечего, и хранить его у себя незачем.
export async function reportDeviceTimezone(timezone: string): Promise<void> {
  await fetch(`${runtimeConfig.ID_BASE_URL}/api/employees/me/timezone`, {
    method: 'PUT',
    credentials: 'include',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ timezone }),
  })
}
